<template>
    <div class="scheme-logo">
        <a v-if="homeUrl"
           class="scheme-logo__wrapper scheme-logo__wrapper--link"
           target="_blank" :href="homeUrl"
           :tabindex="1">
            <h1 v-if="hasLogo" class="scheme-logo__image-wrapper">
                <img class="scheme-logo__image" :src="logoUrl" :alt="mainHeading">
            </h1>
            <h1 v-else class="scheme-logo__text">{{ scaledTitle }}</h1>
        </a>
        <a v-else class="scheme-logo__wrapper"
           :tabindex="1">
            <h1 v-if="hasLogo" class="scheme-logo__image-wrapper">
                <img class="scheme-logo__image" :src="logoUrl" :alt="mainHeading">
            </h1>
            <h1 v-else class="scheme-logo__text">{{ scaledTitle }}</h1>
        </a>
    </div>
</template>

<script>

import Vuex from 'vuex'

export default {

    data() {
        return {
            logoUrl: null,
        }
    },

    computed: {
        ...Vuex.mapState([
            'partnerReferralId',
        ]),

        /**
         * @returns {string}
         */
        fullTitle() {
            return this.$scheme.title
        },

        /**
         * @returns {boolean}
         */
        hasLogo() {
            return this.logoUrl !== null
        },

        /**
         * @returns {string}
         */
        homeUrl() {
            return this.partnerReferralId
                ? this.$scheme.homeUrl.includes('?')
                    ? `${ this.$scheme.homeUrl }&partref=${ this.partnerReferralId }`
                    : `${ this.$scheme.homeUrl }?partref=${ this.partnerReferralId }`
                : this.$scheme.homeUrl
        },

        /**
         * @returns {string}
         */
        mainHeading() {
            return `${ this.fullTitle } Plan Builder`
        },

        /**
         * @returns {string}
         */
        scaledTitle() {
            return this.$scheme.shortTitle
        },
    },

    beforeMount() {
        this._tryLoadLogos()
    },

    methods: {

        _tryLoadLogo(testUrl, failCallback){
            const img = new Image()
            img.onload = () => {
                this.$logger.log(`${ this.$scheme.title } logo found at ${ testUrl }`, 'Asset Loading')
                this.logoUrl = testUrl
            }
            img.onerror = () => {
                this.$logger.log(`${ this.$scheme.title } logo not found at ${ testUrl }`, 'Asset Loading')
                if (failCallback) failCallback()
            }
            img.src = testUrl
        },

        _tryLoadLogos() {
            this._tryLoadLogo(`${ this.$config.baseUrl }schemes/${ this.$scheme.path }/img/logo.svg`,
                () => {
                    this._tryLoadLogo(`${ this.$config.baseUrl }schemes/${ this.$scheme.path }/img/logo.png`)
                })
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

.scheme-logo {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: flex-start;
    height: 100%;
    user-select: none;

    @include element('wrapper') {
        //flex: 3 0 auto;
        height: 100%;
        max-width: 140px;
        background: none;
        text-decoration: none !important;

        @include bp-min-small {
            max-width: 180px;
        }

        @include bp-min-mid {
            max-width: 200px;
        }

        @include modifier('--link') {
            cursor: pointer;
        }
    }

    @include element('image-wrapper') {
        height: 100%;
        margin-bottom: 0;
        line-height: 1em;
    }

    @include element('image') {
        height: 100%;
        width: 100%;
    }

    @include element('text') {
        font-size: 1.3em;
        font-weight: bold;
        margin: 0;
        line-height: 1.5em;

        @include bp-min-small {
            max-height: 2em;
            font-size: 1.6em;
        }
    }
}

</style>

